import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { formatNumber } from '../../../../../utils/numberFormatter';

const CategorySelector = ({
  categories = [],
  selectedCategory = '',
  categoriesLoading = false,
  onSelectCategory,
  isCategoryDisabled,
  productLimits
}) => {
  const renderCategorySkeleton = () => {
    return (
      <div className="row justify-content-center mt-4 rg-tile-grid rg-tile-grid--product-plans">
        {[...Array(3)].map((_, index) => (
          <div className="col-md-3" key={index}>
            <div className="card category-option rg-tile rg-plan-tile--skeleton" aria-hidden="true">
              <div className="card-body text-center">
                <div className="rg-plan-tile__stack">
                  <Skeleton height={22} width={138} />
                  <Skeleton height={34} width={126} />
                  <Skeleton height={20} width={44} borderRadius={10} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (categoriesLoading) {
    return renderCategorySkeleton();
  }

  if (categories.length === 0) {
    return null;
  }

  const visibleCategories = categories.filter((category) => (category.max_capital_effective ?? 0) > 0);

  if (visibleCategories.length === 0) {
    return null;
  }

  return (
    <div className="row justify-content-center rg-tile-grid rg-tile-grid--products rg-tile-grid--product">
      {visibleCategories.map((category) => {
        const maxEffective = category.max_capital_effective ?? 0;
        const disabledByLimits = isCategoryDisabled ? isCategoryDisabled(category) : false;
        const disabled = disabledByLimits;

        return (
          <div className="col-md-3" key={category.id}>
            <div
              className={`card category-option ${selectedCategory === category.id ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={!disabled ? () => onSelectCategory(category.id) : undefined}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}
            >
              <div className="card-body text-center">
                <FontAwesomeIcon icon={category.icon} size="2x" className="mb-3" />
                <h5 className="card-title">{category.name}</h5>
                <div className="rg-category-capital mb-2" aria-label={`Capital máximo ${formatNumber(maxEffective)}`}>
                  <span className="rg-category-capital__amount">${formatNumber(maxEffective)}</span>
                  <span className="rg-category-capital__chip">MAX.</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CategorySelector;
